import { createFileRoute } from '@tanstack/react-router';
import { assessmentComparisonSearchSchema } from '@/pages/assessment/lib/comparisonSearchSchema';
import { AssessmentOverviewPage } from '@/pages/assessment/ui/AssessmentOverviewPage';
import { routeValidateQuerySearch } from '@/shared/lib/route';

export const Route = createFileRoute('/_protected/assessment/$assessmentId/overview/')({
  component: AssessmentOverviewPage,
  // base/diff と同じ schema を適用し、タブ遷移で持ち越した diff 固有の accumulationId を
  // 除去する（sort/order/amount_unit は保持する）。
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: false,
      customSchema: assessmentComparisonSearchSchema,
      defaultValues: undefined,
    }),
});
